import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-603c60bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "grid"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Title*", -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Audience*", -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Scope*", -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Other Redirect Url", -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Sharepoint Redirect Url", -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Confluence Redirect Url", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Jira Redirect Url", -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Mailto", -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Keywords", -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Category*", -1));
const _hoisted_12 = { class: "wp-pages-inputs" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "onedesk-input-label onedesk-input-label-linear" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Upload new icon (Only svg extension is supported)")
], -1));
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Description*", -1));
const _hoisted_15 = { class: "user-save-claims-button-wrapper" };
import { computed, onBeforeMount, ref, } from "vue";
import OneDeskInput from "@/components/atoms/OneDeskInput.vue";
import OneDeskDropdown from "@/components/atoms/OneDeskDropdown.vue";
import { getCatalogCardById, updateCatalogCard, addCatalogCard, } from "@/repositories/catalog-card.repository";
import FileUpload from "primevue/fileupload";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
import ImageWithNoImageDefault from "@/components/atoms/ImageWithNoImageDefault.vue";
import { useStore } from "@/shared/composables/useStore";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import { AllActionTypes } from "@/store/action-types";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import { mandatoryField, maxLength, validateEmail, validateURL } from "@/shared/utils/validation";
import OneDeskTextArea from "@/components/atoms/OneDeskTextArea.vue";
import useFormValidation from "@/shared/composables/useFormValidation";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpsertCatalogCard',
    props: {
        cardId: {},
        fullScreen: { type: Boolean }
    },
    emits: ["card-updated"],
    setup(__props, { emit: __emit }) {
        const { validationStateDict, invalidForm } = useFormValidation();
        const selectedCard = ref({
            title: "",
            description: "",
            audience: "",
            content: "",
            scope: "",
            otherRedirectUrl: "",
            sharepointRedirectUrl: "",
            confluenceRedirectUrl: "",
            jiraRedirectUrl: "",
            keywords: "",
            mailtoAddress: "",
            categoryId: "",
            pictureUri: "",
        });
        const categories = computed(() => store.getters[ReferenceValuesTypes.CATALOGCATEGORIES]);
        const blobUrl = ref("");
        const { cardId = undefined, fullScreen = false } = __props;
        const emit = __emit;
        const notify = useToastNotify();
        const store = useStore();
        const fullScreenOrSideBar = computed(() => fullScreen ? "col-12 lg:col-6" : "col-12");
        onBeforeMount(async () => {
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.CATALOGCATEGORIES);
            await getCardById();
        });
        const getCardById = async () => {
            if (cardId)
                selectedCard.value = await getCatalogCardById(cardId);
        };
        const onSave = async () => {
            if (invalidForm.value) {
                notify("", "Please enter the mandatory fields", "warn");
            }
            else {
                try {
                    const inputCard = buildCardInput();
                    if (cardId) {
                        await updateCatalogCard({
                            id: cardId,
                            ...inputCard,
                        });
                    }
                    else
                        await addCatalogCard(inputCard);
                    notifyUserAndEmitUpdated(cardId ? "updated" : "created");
                }
                catch (error) {
                    notify("", error.message, "warn");
                }
            }
        };
        const buildCardInput = () => {
            return {
                categoryId: selectedCard.value.categoryId,
                title: selectedCard.value.title,
                description: selectedCard.value.description,
                audience: selectedCard.value.audience,
                scope: selectedCard.value.scope,
                otherRedirectUrl: selectedCard.value.otherRedirectUrl,
                sharepointRedirectUrl: selectedCard.value.sharepointRedirectUrl,
                confluenceRedirectUrl: selectedCard.value.confluenceRedirectUrl,
                jiraRedirectUrl: selectedCard.value.jiraRedirectUrl,
                keywords: selectedCard.value.keywords,
                mailtoAddress: selectedCard.value.mailtoAddress,
                base64Picture: selectedCard.value.base64Picture,
            };
        };
        const notifyUserAndEmitUpdated = (action = "updated") => {
            notify("", `Card : ${selectedCard.value.title} has been successfully ${action}`, "success");
            emit("card-updated");
        };
        const upload = (event) => {
            if (event.files && event.files[0]) {
                blobUrl.value = event.files[0].objectURL;
                const reader = new FileReader();
                reader.onload = (e) => selectedCard.value.base64Picture = e.target?.result;
                reader.readAsDataURL(event.files[0]);
            }
        };
        const onClear = () => {
            blobUrl.value = "";
            selectedCard.value.base64Picture = "";
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (selectedCard.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value)
                        }, [
                            _createVNode(OneDeskInput, {
                                "data-testid": "title",
                                modelValue: selectedCard.value.title,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedCard.value.title) = $event)),
                                class: "wp-pages-inputs",
                                "max-length": 100,
                                rules: [_unref(mandatoryField), _unref(maxLength)(100)],
                                "onUpdate:valid": _cache[1] || (_cache[1] = ($event) => (_unref(validationStateDict).title = $event))
                            }, {
                                label: _withCtx(() => [
                                    _hoisted_2
                                ]),
                                _: 1
                            }, 8, ["modelValue", "rules"])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value)
                        }, [
                            _createVNode(OneDeskInput, {
                                "data-testid": "audience",
                                modelValue: selectedCard.value.audience,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedCard.value.audience) = $event)),
                                class: "wp-pages-inputs",
                                "max-length": 50,
                                rules: [_unref(mandatoryField), _unref(maxLength)(50)],
                                "onUpdate:valid": _cache[3] || (_cache[3] = ($event) => (_unref(validationStateDict).audience = $event))
                            }, {
                                label: _withCtx(() => [
                                    _hoisted_3
                                ]),
                                _: 1
                            }, 8, ["modelValue", "rules"])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value)
                        }, [
                            _createVNode(OneDeskInput, {
                                "data-testid": "scope",
                                modelValue: selectedCard.value.scope,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedCard.value.scope) = $event)),
                                class: "wp-pages-inputs",
                                "max-length": 100,
                                rules: [_unref(mandatoryField), _unref(maxLength)(100)],
                                "onUpdate:valid": _cache[5] || (_cache[5] = ($event) => (_unref(validationStateDict).scope = $event))
                            }, {
                                label: _withCtx(() => [
                                    _hoisted_4
                                ]),
                                _: 1
                            }, 8, ["modelValue", "rules"])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value)
                        }, [
                            _createVNode(OneDeskInput, {
                                "data-testid": "otherRedirectUrl",
                                modelValue: selectedCard.value.otherRedirectUrl,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedCard.value.otherRedirectUrl) = $event)),
                                class: "wp-pages-inputs",
                                rules: [_unref(validateURL)],
                                "onUpdate:valid": _cache[7] || (_cache[7] = ($event) => (_unref(validationStateDict).otherRedirectUrl = $event))
                            }, {
                                label: _withCtx(() => [
                                    _hoisted_5
                                ]),
                                _: 1
                            }, 8, ["modelValue", "rules"])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value)
                        }, [
                            _createVNode(OneDeskInput, {
                                "data-testid": "sharepointRedirectUrl",
                                modelValue: selectedCard.value.sharepointRedirectUrl,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((selectedCard.value.sharepointRedirectUrl) = $event)),
                                class: "wp-pages-inputs",
                                rules: [_unref(validateURL)],
                                "onUpdate:valid": _cache[9] || (_cache[9] = ($event) => (_unref(validationStateDict).sharepointRedirectUrl = $event))
                            }, {
                                label: _withCtx(() => [
                                    _hoisted_6
                                ]),
                                _: 1
                            }, 8, ["modelValue", "rules"])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value)
                        }, [
                            _createVNode(OneDeskInput, {
                                "data-testid": "confluenceRedirectUrl",
                                modelValue: selectedCard.value.confluenceRedirectUrl,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((selectedCard.value.confluenceRedirectUrl) = $event)),
                                class: "wp-pages-inputs",
                                rules: [_unref(validateURL)],
                                "onUpdate:valid": _cache[11] || (_cache[11] = ($event) => (_unref(validationStateDict).confluenceRedirectUrl = $event))
                            }, {
                                label: _withCtx(() => [
                                    _hoisted_7
                                ]),
                                _: 1
                            }, 8, ["modelValue", "rules"])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value)
                        }, [
                            _createVNode(OneDeskInput, {
                                "data-testid": "jiraRedirectUrl",
                                modelValue: selectedCard.value.jiraRedirectUrl,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((selectedCard.value.jiraRedirectUrl) = $event)),
                                class: "wp-pages-inputs",
                                rules: [_unref(validateURL)],
                                "onUpdate:valid": _cache[13] || (_cache[13] = ($event) => (_unref(validationStateDict).jiraRedirectUrl = $event))
                            }, {
                                label: _withCtx(() => [
                                    _hoisted_8
                                ]),
                                _: 1
                            }, 8, ["modelValue", "rules"])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value)
                        }, [
                            _createVNode(OneDeskInput, {
                                "data-testid": "mailtoAddress",
                                modelValue: selectedCard.value.mailtoAddress,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((selectedCard.value.mailtoAddress) = $event)),
                                onInput: _cache[15] || (_cache[15] = ($event) => (_unref(validateEmail)($event))),
                                class: "wp-pages-inputs",
                                rules: [_unref(validateEmail)],
                                "onUpdate:valid": _cache[16] || (_cache[16] = ($event) => (_unref(validationStateDict).mailtoAddress = $event))
                            }, {
                                label: _withCtx(() => [
                                    _hoisted_9
                                ]),
                                _: 1
                            }, 8, ["modelValue", "rules"])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value)
                        }, [
                            _createVNode(OneDeskInput, {
                                "data-testid": "keywords",
                                modelValue: selectedCard.value.keywords,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((selectedCard.value.keywords) = $event)),
                                class: "wp-pages-inputs"
                            }, {
                                label: _withCtx(() => [
                                    _hoisted_10
                                ]),
                                _: 1
                            }, 8, ["modelValue"])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value)
                        }, [
                            _createVNode(OneDeskDropdown, {
                                "data-testid": "categoryId",
                                modelValue: selectedCard.value.categoryId,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((selectedCard.value.categoryId) = $event)),
                                options: categories.value,
                                class: "wp-pages-inputs",
                                lineraLabel: false,
                                fullWidth: true,
                                optionValue: "id",
                                optionLabel: "label",
                                required: true,
                                "onUpdate:valid": _cache[19] || (_cache[19] = ($event) => (_unref(validationStateDict).categoryId = $event))
                            }, {
                                label: _withCtx(() => [
                                    _hoisted_11
                                ]),
                                _: 1
                            }, 8, ["modelValue", "options"])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value)
                        }, [
                            _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                _createVNode(ImageWithNoImageDefault, {
                                    "data-testid": "pictureUri",
                                    class: "mb-3",
                                    source: selectedCard.value?.pictureUri,
                                    "assets-folder": "catalog-cards"
                                }, null, 8, ["source"]),
                                _createVNode(_unref(FileUpload), {
                                    "data-testid": "fileUpload",
                                    customUpload: true,
                                    onSelect: upload,
                                    onClear: onClear,
                                    mode: "advanced",
                                    accept: ".svg",
                                    showCancelButton: true,
                                    showUploadButton: false,
                                    fileLimit: 1
                                })
                            ])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(fullScreenOrSideBar.value),
                            style: { "display": "flex", "flex-direction": "column" }
                        }, [
                            _hoisted_14,
                            _createVNode(OneDeskTextArea, {
                                "data-testid": "description",
                                class: "description-input",
                                modelValue: selectedCard.value.description,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((selectedCard.value.description) = $event)),
                                rows: 10,
                                cols: 35,
                                "max-length": 250,
                                rules: [_unref(mandatoryField)],
                                "onUpdate:valid": _cache[21] || (_cache[21] = ($event) => (_unref(validationStateDict).description = $event))
                            }, null, 8, ["modelValue", "rules"])
                        ], 2)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createElementVNode("div", _hoisted_15, [
                        _createVNode(OneDeskButton, {
                            class: "save-button",
                            icon: "pi pi-save",
                            label: "Save",
                            onClick: onSave,
                            disabled: _unref(invalidForm)
                        }, null, 8, ["disabled"])
                    ])
                ], 2)
            ], 64));
        };
    }
});
